export class RestApiResponse<T> {
    status: string;
    isSuccess: boolean;
    message: string | undefined;
    data: T | null| undefined;
  
    constructor(data: T | null | undefined, message: string | undefined, success: boolean) {
      this.message = message;
      this.isSuccess = success;
      this.status = success ? 'success' : 'failed';
      this.data = data;
    }
   
  }
   
  